"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function DownThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "4.693 2.749 4.693 10.249 12.193 10.249 12.193 11.249 3.693 11.249 3.693 2.749", transform: "rotate(-45 6.736 6.5)" })));
}
exports.default = DownThin;
//# sourceMappingURL=DownThin.js.map